// extracted by mini-css-extract-plugin
module.exports = {"root":"fe305f94c1ee80fd6897f8d4a3d9e3db-less","content":"_1d4d6fa276c62035cd464bf6bd3a0dd1-less"};